<template>

    <div class="more-info-overlay">

        <div class="container tp-lvl" :class="{ clsng : Global.tempPreviewClosingOverlay }">

            <!-- visu left -->

            <!-- nav left -->
            <!-- <div class="nv bw">
                <span class="ico">
                    <svg width="17" height="40" viewBox="0 0 17 40" fill="none">
                        <path d="M15 38L2.42285 20.5855C2.17042 20.236 2.17043 19.764 2.42285 19.4145L15 2" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div> -->

            <div class="inner">
                <div class="centered-content">
                    <div class="visu-head">
                        <div class="vis-wrapper" :class="{ p : vidPlaying }">
                            <div class="vid-container">
                                <video width="1680" height="944" playsinline loop muted ref="player">
                                    <source type="video/mp4" :src="asset.video">
                                </video>
                            </div>
                            <div class="pics">
                                <div class="pic cvr" :style="{backgroundImage: 'url('+asset.poster+')'}"></div>
                                <!-- <div class="pic cvr" style="background-image:url('/img/preview/mad.jpg')"></div> -->
                            </div>
                            <!-- <div class="pic cvr" style="background-image:url('/img/preview/mad.jpg')"></div> -->
                        </div>
                        <div class="cntnr tp">
                            <div class="sqr arw" @click.prevent="closeOverlay">
                                <span class="ico">
                                    <svg width="22" height="12" viewBox="0 0 22 12" fill="none">
                                    <path d="M1.5 1.5L10.3123 9.84845C10.698 10.2138 11.302 10.2138 11.6877 9.84845L20.5 1.5" stroke="white" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="sqr spn" v-if="!vidPlaying">
                                <span class="ico">
                                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none">
                                        <path d="M2 14.5003C1.99993 11.5785 3.02338 8.749 4.89257 6.50331C6.76177 4.25762 9.35858 2.73768 12.2319 2.20752C15.1052 1.67736 18.0735 2.17049 20.621 3.60124C23.1685 5.03199 25.1344 7.30995 26.177 10.0394C27.2197 12.7688 27.2732 15.7773 26.3284 18.5421C25.3836 21.307 23.5001 23.6535 21.0051 25.174C18.5101 26.6945 15.5613 27.293 12.6709 26.8655C9.78056 26.4379 7.13128 25.0114 5.18333 22.8337" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </div>
                            <div class="sqr vol" v-else @click.prevent="toggleMute" :class="{ mtd : isMuted }">
                                <span class="ico">
                                    <!-- <svg width="29" height="23" viewBox="0 0 29 23" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.91872H3.33333C2.59733 6.91872 2 7.51605 2 8.25205V14.5854C2 15.3214 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4134C12.672 21.1481 14 20.5321 14 19.3961V3.44138C14 2.30538 12.6707 1.68938 11.8053 2.42405L6.5 6.91872Z" fill="white" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M19.3828 16.7226C20.9321 15.76 22.0001 13.7573 22.0001 11.4253C22.0001 9.09329 20.9321 7.08929 19.3828 6.11462" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M23.3407 20.8387C25.7513 18.7653 27.334 15.3253 27.334 11.4227C27.334 7.51467 25.7487 4.072 23.334 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg> -->
                                    <svg width="35" height="23" viewBox="0 0 35 23" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.91867H3.33333C2.59733 6.91867 2 7.516 2 8.252V14.5853C2 15.3213 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4133C12.672 21.148 14 20.532 14 19.396V3.44133C14 2.30533 12.6707 1.68933 11.8053 2.424L6.5 6.91867Z" fill="white" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M19.3827 16.7227C20.932 15.76 22 13.7573 22 11.4253C22 9.09333 20.932 7.08933 19.3827 6.11467" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="vol-bar"/>
                                    <path d="M23.34 20.8387C25.7507 18.7653 27.3333 15.3253 27.3333 11.4227C27.3333 7.51467 25.748 4.072 23.3333 2" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="vol-bar"/>
                                    <rect width="3" height="15" rx="1.5" transform="matrix(0.707103 0.70711 -0.707103 0.70711 27.8491 5.24249)" fill="white"/>
                                    <rect width="3" height="15" rx="1.5" transform="matrix(0.707107 -0.707107 0.707114 0.7071 17.2427 7.36389)" fill="white"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                        <div class="cntnr">
                            <div class="content col">
                                <!-- <h1 class="txt-grt-pnk">Bonding</h1> -->
                                <h1 :style="{ color : Global.mockupConfig.colors.icons }">{{ asset.name }}</h1>
                                <div class="actions">
                                    <div class="btn main ply sub" @click.prevent="openSubOverlay" :style="{ background : Global.mockupConfig.colors.icons }"
                                        v-if="asset.planIndex != 0"
                                    >
                                        <span class="ico">
                                            <svg width="21" height="24" viewBox="0 0 21 24" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z" fill="black"/>
                                            </svg>
                                        </span>
                                        <span class="txt">Subscribe</span>
                                    </div>
                                    <div class="btn main ply" @click.prevent="play" :style="{ background : Global.mockupConfig.colors.icons }"
                                        v-else
                                    >
                                        <span class="ico">
                                            <svg width="21" height="24" viewBox="0 0 21 24" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z" fill="black"/>
                                            </svg>
                                        </span>
                                        <span class="txt" v-if="asset.progressPerc">Resume</span>
                                        <span class="txt" v-else>Play</span>
                                    </div>
                                    <div class="sqr add">
                                        <span class="ico">
                                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                            <path d="M13 2V24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M2 13H24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                    </div> 
                                    <div class="sqr like">
                                        <span class="ico">
                                            <svg width="27" height="25" viewBox="0 0 27 25" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.79011 23.256C1.11773 23.256 0.57373 22.6008 0.57373 21.7908V10.3052C0.57373 9.4953 1.11773 8.84003 1.79011 8.84003H4.79735C5.46973 8.84003 6.01373 9.4953 6.01373 10.4153V21.9009C6.01373 22.6008 5.46973 23.256 4.79735 23.256H1.79011Z" fill="white"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.58203 10.4797L12.8542 1.85176C14.8848 -1.46977 17.0079 -0.0332005 17.0079 3.86238L16.1579 8.4177H20.3998H22.1705C23.4642 8.4177 24.6723 9.06602 25.392 10.1484C26.0289 11.1052 26.2146 12.2962 25.8976 13.4014L23.807 22.3335C23.4528 23.5673 22.3247 24.4184 21.0424 24.4184H12.9513C12.1202 24.4184 11.312 24.1271 10.6722 23.5958L7.58203 21.034V10.4797Z" fill="white"/>
                                            </svg>
                                        </span>
                                    </div> 
                                    <div class="sqr dislike">
                                        <span class="ico">
                                            <svg width="31" height="29" viewBox="0 0 31 29" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M28.8939 1.54C29.685 1.54 30.325 2.31091 30.325 3.26375L30.325 16.7762C30.325 17.7291 29.685 18.5 28.8939 18.5H25.356C24.565 18.5 23.925 17.7291 23.925 16.6467V3.13424C23.925 2.31091 24.565 1.54 25.356 1.54H28.8939Z" fill="white"/>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0798 16.6709L15.8773 26.8215C13.4883 30.7291 10.9906 29.0391 10.9906 24.456L11.9906 19.0968H7.00015H4.91695C3.39487 19.0968 1.97359 18.3341 1.12687 17.0607C0.377594 15.9351 0.159195 14.5339 0.532154 13.2336L2.99167 2.7253C3.40831 1.27378 4.73551 0.272499 6.24415 0.272499L15.763 0.272499C16.7408 0.272499 17.6917 0.615219 18.4443 1.24018L22.0798 4.2541L22.0798 16.6709Z" fill="white"/>
                                            </svg>
                                        </span>
                                    </div> 
                                </div>
                                <div class="infos">
                                    <p class="sum">{{ asset.description }}</p>
                                    <div class="tags ft-bld">
                                        <span class="tag" v-for="tag in asset.tags" :key="tag">
                                            {{ tag }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="more">
                        <div class="cntnr">
                            <CatRow
                                row-title="Related contents"
                            >
                                <RowCard v-for="asset in relatedAssets" :key="asset.index"
                                    :posterSrc="asset.poster"
                                    :title="asset.name"
                                    :description="asset.description"
                                    :moneyTag="Global.plans[asset.planIndex].name"
                                    :index="asset.index"
                                ></RowCard>
                            </CatRow>
                        </div>
                    </div>
                </div>
            </div>

            <!-- visu right -->

            <!-- nav right -->
            <!-- <div class="nv fw">
                <span class="ico">
                    <svg width="17" height="40" viewBox="0 0 17 40" fill="none">
                        <path d="M2 2L14.5771 19.4145C14.8296 19.764 14.8296 20.236 14.5771 20.5855L2 38" stroke="white" stroke-width="4" stroke-linejoin="round"/>
                    </svg>
                </span>
            </div> -->
            
        </div>
        
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'
    import RowCard from '../components/RowCard'
    import CatRow from '../components/CatRow'
    import { EventBus } from '../event-bus.js'

    export default {

        name: 'PreviewInfoOverlay',

        components: {
            RowCard,
            CatRow
        },

        props: {
            
        },

        data() {
            return {
                Global,
                vidPlaying: false,
                isMuted: true
            }
        },

        computed: {
            asset() {
                if(this.Global.assets[this.Global.assetIndexToShow] == undefined) {
                    return {}
                }
                
                return this.Global.assets[this.Global.assetIndexToShow]
            },

            relatedAssets() {
                const assets =  Object.assign([], this.Global.assets)
                const shuffled = [...assets].sort(() => 0.5 - Math.random());

                const results = shuffled.filter((asset) => {
                    if(asset.index == this.asset.index) {
                        return false
                    }

                    return this.asset.tags.some((tag) => asset.tags.includes(tag))
                })

                return results.slice(0,3)
            }
        },

        mounted() {
            setTimeout(() => { this.launchVid() }, 1500)
        },

        methods: {

            launchVid() {
                this.$refs.player.play()
                this.vidPlaying = true
            },

            toggleMute() {
                if(this.$refs.player.muted){
                    this.$refs.player.muted = false
                    this.isMuted = false
                }else{
                    this.$refs.player.muted = true
                    this.isMuted = true
                }
            },

            async play() {
                if(this.asset.planIndex != 0) {
                    return this.openSubOverlay()
                }
                
                await this.closeOverlay()
                this.Global.assetIndexToPlay = this.asset.index
                this.$router.push('/player').catch(()=>{});
            },

            closeOverlay() {
                return new Promise((resolve) => {
                    EventBus.$emit('closingOverlayInfo');
                    this.Global.tempPreviewClosingOverlay = true
                    setTimeout(() => { this.Global.activePreviewOverlay = false }, 300)
                    setTimeout(() => { 
                        this.Global.activePreviewInfoOverlay = false 
                        resolve()
                    }, 600)
                })
            },

            openSubOverlay() {
                this.Global.tempSubClosingOverlay = false
                this.Global.activeSubOverlay = true
                this.Global.activeSubInfoOverlay = true
            }
        }
    }
</script>